import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 21h4v-4h-4v-6h4v-4h-4v-4h-4v1a3 3 0 0 1 -3 3h-1v4h4v6a4 4 0 0 0 4 4","key":"svg-0"}]]

/**
 * IconBrandTumblr
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtdHVtYmxyIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xNCAyMWg0di00aC00di02aDR2LTRoLTR2LTRoLTR2MWEzIDMgMCAwIDEgLTMgM2gtMXY0aDR2NmE0IDQgMCAwIDAgNCA0IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/brand-tumblr
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandTumblr = createReactComponent('outline', 'brand-tumblr', 'BrandTumblr', __iconNode);

export default IconBrandTumblr;